module.exports = __webpack_public_path__ + "static/media/stmichael.42dee2a0.webp";